import React, { useState } from "react";
import styles from "./sobre_mim_cubonetattoo.module.scss";
import InstagramIcon from '../../icons/instagramIcon.tsx';
import MapsIcon from '../../icons/mapsIcon.tsx';
import WhatsappIcon from '../../icons/whatsappIcon.tsx';
import { Link } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";

const artists = {
    rafael: {
        name: "Rafael Cubone",
        image: require("./src/img_sobremim.png"),
        imageAlt: "Rafael Cubone",
        paragraphs: [
            "Com mais de 10 anos de experiência, sou tatuador premiado mais de 30 vezes em convenções e proprietário do estúdio mais completo da região. Especialista em neo tradicional, também desenvolvo trabalhos nos estilos blackwork, preto e cinza, old school, fineline, ornamental, botânico, tribal e cobertura, sempre respeitando a individualidade e essência de cada cliente.",
            "Como artista plástico, grafiteiro e muralista, encontro inspiração na arte nouveau e na anatomia do corpo humano, criando tattoos que se integram perfeitamente à pele. Também sou artista destaque em tatuagem em pele negra, e trabalho com camuflagem de estrias e cicatrizes, elevando a autoestima e confiança de quem passa pelo meu estúdio.",
            "Meu compromisso é com qualidade, dedicação e exclusividade: estudo e me aprofundo constantemente em técnicas e referências para entregar arte única para cada cliente.",
        ],
        whatsapp: "https://wa.me/5517997449691?text=Olá, vim pelo link na bio e gostaria de mais informações...",
        maps: "https://maps.app.goo.gl/NnYiDFBX8zqoTtnR7",
        instagram: "https://www.instagram.com/cubonetattoo?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==",
    },
    tayna: {
        name: "Tayná Frasson",
        image: require("../tayfrassontattoo/src/img_sobremim.png"),
        imageAlt: "Tayná Frasson",
        paragraphs: [
            "Com mais de 6 anos de experiência, sou tatuadora apaixonada pela arte de transformar sentimentos em histórias na pele. Ao longo da minha trajetória, fui premiada mais de 25 vezes em eventos de tatuagem, reconhecimento que fortalece ainda mais meu compromisso com qualidade e inovação.",
            "Sou especialista em fineline, técnica que exige precisão, delicadeza e sensibilidade. Além disso, desenvolvo trabalhos nos estilos ornamental, preto e cinza, pontilhismo, botânico, mini realismo pet, sticker, bordado e glitter, sempre respeitando a essência e a individualidade de cada cliente.",
            "Minha missão vai além da tatuagem: busco elevar a autoestima de quem confia no meu trabalho, criando não apenas desenhos, mas experiências únicas. Estou em constante busca por atualização e aperfeiçoamento, para oferecer sempre o que há de melhor em qualidade, técnica e criatividade.",
        ],
        whatsapp: "https://wa.me/5518997958605?text=Olá, vim pelo link na bio e gostaria de mais informações...",
        maps: "https://maps.app.goo.gl/NnYiDFBX8zqoTtnR7",
        instagram: "https://www.instagram.com/tayfrasson.tattoo?igsh=OWhtbGxhZDI0NzZ5",
    },
};

const Sobre_mim_cubonetattoo: React.FC = () => {
    const [selectedArtist, setSelectedArtist] = useState<"rafael" | "tayna">("rafael");
    const currentArtist = artists[selectedArtist];

    return (
        <div className={styles.sobre_mim_cubonetattoo}>
            {/* HEADER */}
            <div className={styles.header}>
                <Link to="/cubonetattoo" className={styles.backButton}>
                    <FaArrowLeft />
                </Link>
                <h1 className="mb-0">Sobre mim</h1>
            </div>

            {/* CONTEÚDO */}
            <div className={styles.content}>
                <div className={styles.artistTabs}>
                    <button
                        type="button"
                        className={`${styles.artistTab} ${selectedArtist === "rafael" ? styles.activeTab : ""}`}
                        onClick={() => setSelectedArtist("rafael")}
                    >
                        Rafael Cubone
                    </button>
                    <button
                        type="button"
                        className={`${styles.artistTab} ${selectedArtist === "tayna" ? styles.activeTab : ""}`}
                        onClick={() => setSelectedArtist("tayna")}
                    >
                        Tayná Frasson
                    </button>
                </div>

                <div className={styles.imageContainer}>
                    <img src={currentArtist.image} alt={currentArtist.imageAlt} />
                </div>
                <h2>{currentArtist.name}</h2>
                {currentArtist.paragraphs.map((paragraph) => (
                    <p key={paragraph}>
                        {paragraph}
                    </p>
                ))}
            </div>

            {/* FOOTER */}
            <div className={styles.footer}>
                <div className={styles.divSocials}>
                    <a href={currentArtist.whatsapp} target="_blank" rel="noreferrer">
                        <div className={styles.socials}>
                            <div className={styles.iconPlaceholder}><WhatsappIcon height="30" color="#ffffff" /></div>
                            <span>WhatsApp</span>
                        </div>
                    </a>
                    <a href={currentArtist.maps} target="_blank" rel="noreferrer">
                        <div className={styles.socials}>
                            <div className={styles.iconPlaceholder}><MapsIcon height="30" color="#ffffff" /></div>
                            <span>Localização</span>
                        </div>
                    </a>
                    <a href={currentArtist.instagram} target="_blank" rel="noreferrer">
                        <div className={styles.socials}>
                            <div className={styles.iconPlaceholder}><InstagramIcon height="26" color="#ffffff" /></div>
                            <span>Instagram</span>
                        </div>
                    </a>
                </div>
                <div className={styles.signature}>
                    Desenvolvido por{" "}
                    <a href="https://www.linksvibe.com.br" target="_blank" rel="noreferrer">
                        Links Vibe
                    </a>
                </div>
            </div>
        </div>
    );
};

export default Sobre_mim_cubonetattoo;
